import { useEffect, useState } from 'react'
import { CardDash } from '../../Components/CardDash'
import CardDashGrafico from '../../Components/CardDashGrafico'
import Calendar from '../../../../componentsNew/Calendar'
import { useGetMedias } from '../../../../api/controllers/artigo'
import { useSelect } from '@wordpress/data'
import { differenceInDays, addMonths, subMonths,getDaysInMonth } from 'date-fns'
import { store } from '../../../../redux/store'

export function PanoramaGeral() {
    const idBlog = useSelect(select => select(store).getBlogIdOpti())
    const [dataInicial, setDataInicial] = useState(new Date((new Date()).setMonth((new Date()).getMonth() - 1)));
    const [dataFinal, setDataFinal] = useState(new Date());
    const { data, isLoading } = useGetMedias(idBlog, dataInicial, dataFinal)

    useEffect(() => {
        if (Math.abs(differenceInDays(dataInicial, dataFinal)) > getDaysInMonth(dataInicial))
            setDataFinal(addMonths(dataInicial, 1))
    }, [dataInicial]);

    useEffect(() => {
        if (Math.abs(differenceInDays(dataInicial, dataFinal)) > getDaysInMonth(dataFinal))
            setDataInicial(subMonths(dataFinal, 1))
    }, [dataFinal]);

    return (
        <CardDash titulo="Panorama Geral" className="w-2/5" id="grafico_dash">
            <div className='grid grid-cols-2 gap-4 mt-6'>
                <Calendar
                    className="w-full"
                    label="Período Inicial"
                    selectedDate={dataInicial}
                    setSelectedDate={setDataInicial}
                    loading={isLoading} />
                <Calendar
                    className="w-full"
                    label="Período Final"
                    selectedDate={dataFinal}
                    setSelectedDate={setDataFinal}
                    loading={isLoading} />
            </div>
            <CardDashGrafico
                data={data?.data?.find((e) => e?.tipo == 1)}
                textoLegenda="Média de posição"
                tituloAtual="Mês atual"
                tituloAnterior="Mês anterior"
                titulo="Ranqueamento Geral"
                descricao="Ranqueamento de posições na SERP (Página de Resultados do Mecanismo de Busca) refere-se à ordem em que os resultados de pesquisa aparecem após uma consulta no Google ou em outros mecanismos de busca. Quanto mais alta a posição de um site ou página, maior a visibilidade e a probabilidade de cliques pelos usuários." />
            <CardDashGrafico
                data={data?.data?.find((e) => e?.tipo == 2)}
                tituloAtual="Nas últimas 24 horas"
                tituloAnterior="No último mês"
                titulo="Trafego de Usuários"
                descricao="O tráfego de artigos em um blog Wordpress refere-se ao número de visitantes que acessam e interagem com os seus artigos. Aumentar o tráfego é fundamental para expandir a visibilidade do seu conteúdo e atrair mais leitores" />
        </CardDash>
    )
}
